import { useQuery } from "@tanstack/react-query";
import type { Moment } from "moment-timezone";
import type {
	IncentiveRow,
	IncentiveReportSummary,
} from "../../models/IncentiveRow";
import { getIncentiveReport } from "../../repositories/IncentiveRepository";

export const useIncentiveReport = (
	startDate: Moment,
	endDate: Moment,
	crews: string[],
	shift: string | null,
	enabled = true,
) => {
	const startStr = startDate.format("YYYY-MM-DD");
	const endStr = endDate.format("YYYY-MM-DD");

	return useQuery<
		{ rows: IncentiveRow[]; summary: IncentiveReportSummary },
		Error
	>({
		queryKey: ["incentive-report", startStr, endStr, crews, shift],
		queryFn: ({ signal }) =>
			getIncentiveReport(startStr, endStr, crews, shift, signal),
		enabled,
	});
};
